module.exports = __webpack_public_path__ + "omniv2/img/icon-person.e946c224.svg";